import { render, staticRenderFns } from "./AuthoriseOpg.vue?vue&type=template&id=3af8609c&scoped=true"
import script from "./AuthoriseOpg.vue?vue&type=script&lang=js"
export * from "./AuthoriseOpg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af8609c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af8609c')) {
      api.createRecord('3af8609c', component.options)
    } else {
      api.reload('3af8609c', component.options)
    }
    module.hot.accept("./AuthoriseOpg.vue?vue&type=template&id=3af8609c&scoped=true", function () {
      api.rerender('3af8609c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AuthoriseOpg.vue"
export default component.exports